import React from 'react';

const PriceTagIcon = () => (
  <svg width="10px" height="10px" viewBox="0 0 10 10" fill="#0c4287">
    <g id="QuotePillActivated" transform="translate(-86.000000, -31.000000)">
      <g id="Estimate">
        <g id="Price-Tag" transform="translate(71.333903, 26.299850)">
          <g id="Price-Tag-Icon-Orange" transform="translate(14.769231, 4.709895)">
            <path
              d="M7.26333901,3.50237894 C6.89541276,3.87119958 6.29828657,3.87119958 5.93036033,3.50237894 C5.56243408,3.13355831 5.56243408,2.53498056 5.93036033,2.16615992 C6.29828657,1.79733929 6.89541276,1.79733929 7.26333901,2.16615992 C7.63126525,2.53498056 7.63126525,3.13355831 7.26333901,3.50237894 L7.26333901,3.50237894 Z M5.30684598,0 L2.27373675e-13,5.3197464 L4.22021955,9.55022489 L9.52706553,4.23047849 L9.24433532,0.283417496 L5.30684598,0 Z"
              id="Price-Tag-Icon"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default PriceTagIcon;
